import type { FunnelOffer } from './types';

/**
 * Resolves an authored cart action to exactly one server-owned step offer.
 * Missing product/variant bindings and ambiguous matches fail closed so the
 * browser never chooses which price should be authorized.
 */
export function resolveCartActionOffer(
  offers: readonly FunnelOffer[] | undefined,
  activeOffer: FunnelOffer | null | undefined,
  productId: string,
  variantId: string
): FunnelOffer | null {
  const candidatesById = new Map<string, FunnelOffer>();
  for (const candidate of [...(offers ?? []), ...(activeOffer ? [activeOffer] : [])]) {
    if (candidate.id && !candidatesById.has(candidate.id)) {
      candidatesById.set(candidate.id, candidate);
    }
  }

  const matches = [...candidatesById.values()].filter(
    (candidate) =>
      Boolean(candidate.productId) &&
      Boolean(candidate.variantId) &&
      candidate.productId === productId &&
      (!variantId || candidate.variantId === variantId)
  );

  return matches.length === 1 ? matches[0] : null;
}
